import React from 'react';
import { get } from 'lodash';
import HomepageBL from '../../homepage/HomepageBL';
import NumberUtils from '../../../utils/NumberUtils';
import ProductUtils from '../../../utils/ProductUtils';

const { isOriginalRegularSaverProductCode760, isRegularSaverProductCodes } =
  ProductUtils;

const isRegularSaver = (accountDetails) => {
  const productCode = accountDetails?.product?.code;
  return (
    isOriginalRegularSaverProductCode760(productCode) ||
    isRegularSaverProductCodes(productCode)
  );
};

const isRegularSaverWithInterest = (accountDetails) => {
  const productCode = accountDetails?.product?.code;
  return isRegularSaverProductCodes(productCode);
};

export const AccountSummaryText = ({
  account,
  accountInterestRegularSaverText = '',
}) => {
  /**
   * Summary Text for Current Accounts
   */

  const interestRate = get(account, 'accountDetails.interest_rate');
  if (
    account.type === 'current' &&
    get(account, 'accountDetails.overDraft') > 0
  ) {
    const overdraft = HomepageBL.shouldShowAvailableBalance(account)
      ? `Including ${NumberUtils.appendCurrency(
          '{}',
          account.accountDetails.overDraft
        )} overdraft`
      : `${NumberUtils.appendCurrency(
          '{}',
          account.accountDetails.overDraft
        )} arranged overdraft`;
    return <div className="cardsticky__hide">{overdraft}</div>;
  }

  /**
   * Summary Text for Savings accounts
   */

  if (
    account.type === 'savings' &&
    typeof interestRate === 'number'
    // assert that `interest_rate` is a number as 0 is falsey in JavaScript.
  ) {
    return isRegularSaver(account) ? (
      /**
       * Unlike other savings accounts. Don't content without "hiding" until the "More" button is clicked.
       *
       * Reg saver 632 returns an api interest_rate + different text. Whereas 760 is hardcoded.
       * Should look to have all new reg saver product setups be dynamic to interest_rate to avoid hardcoding
       */
      <div>
        {isRegularSaverWithInterest(account) && `${interestRate}% Gross. `}
        {accountInterestRegularSaverText}
      </div>
    ) : (
      <div className="cardsticky__hide">
        {`Savings interest rate ${interestRate}% Gross.`}
      </div>
    );
  }

  /**
   * Summary Text for Credit Cards
   */
  if (
    account.type === 'credit_card' &&
    account.accountDetails &&
    !account.accountDetails.error
  ) {
    const creditMessage = `Based on your credit limit of ${NumberUtils.appendCurrency(
      '{}',
      account.accountDetails.creditLimit
    )}`;
    return account.accountDetails.creditLimit ? (
      <div className="cardsticky__hide">{creditMessage}</div>
    ) : null;
  }

  return null;
};
